module.exports = __webpack_public_path__ + "static/media/sb.b9736078.svg";